var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRainAvailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8D029F1C-AE5F-4498-AE73-2A9154F69194") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-34.4%",
    y: "-34.4%",
    width: "168.8%",
    height: "168.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-with-VRG",
    transform: "translate(-555.000000, -473.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker/rainGauge",
    transform: "translate(556.000000, 474.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter-1)",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 3,
    fill: "#62C4C3",
    cx: 16,
    cy: 16,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(8.500000, 8.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,10.5 C1.34314575,10.5 2.02906125e-16,9.15685425 0,7.5 C-1.44932947e-17,7.38165327 0.00685278444,7.26490709 0.020183194,7.15013662 C0.00698827134,7.01560236 0,6.88361728 0,6.75 C0,4.85043065 1.41239061,3.28074281 3.24430183,3.03380648 C3.85150774,1.26903416 5.52755447,0 7.5,0 C9.98528137,0 12,2.01471863 12,4.5 L12,4.5 C13.6568542,4.5 15,5.84314575 15,7.5 C15,9.15685425 13.6568542,10.5 12,10.5 L3,10.5 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.75,
    y1: 13.5,
    x2: 1.95,
    y2: 15.9,
    id: "Line",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 13.5,
    x2: 5.7,
    y2: 15.9,
    id: "Line-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.25,
    y1: 13.5,
    x2: 9.45,
    y2: 15.9,
    id: "Line-Copy-2",
    strokeLinecap: "round"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainAvailable);
export default __webpack_public_path__ + "static/media/RainAvailable.63dc6d1f989f129f527aaa30ad8dfe2d.svg";
export { ForwardRef as ReactComponent };